import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ClientDetailBlock } from "../components/ClientDetailBlock";
import { TCMLogo } from "../components/TCMLogo";

export default function AdminClientDetailPage() {
  const { tripId } = useParams();
  const nav = useNavigate();
  return (
    <div className="min-h-screen" data-testid="admin-client-detail-page">
      <div className="border-b border-[color:var(--tcm-navy-15)] px-8 py-4 flex items-center gap-4 bg-[color:var(--tcm-cream)]">
        <div className="flex-1 flex items-center gap-4">
          <TCMLogo size="md" />
          <span className="tcm-eyebrow">Portal Management · Client detail</span>
        </div>
        <button data-testid="back-to-dashboard-btn" onClick={() => nav("/admin")} className="tcm-btn-outline text-[11px] py-2 px-3">Back to dashboard</button>
        <button data-testid="open-trip-editor-btn" onClick={() => nav(`/admin/trips/${tripId}`)} className="tcm-btn-primary text-[11px] py-2 px-3">Open trip editor</button>
      </div>
      <main className="px-8 lg:px-12 py-10 max-w-[900px] mx-auto">
        <ClientDetailBlock tripId={tripId} />
      </main>
    </div>
  );
}
